<template>
  <div class="video_box">
    <section class="w3l-videohny" id="video">
      <div class="new-block py-5">
        <div class="container py-lg-5">
          <div class="video_title">
            <div
              v-for="(item, index) in videoList"
              :key="index"
              @click="changeVideo(index)"
              style=""
              class="title_text"
            >
              <span :class="videoOption == index ? 'sb' : ''">{{
                item.videoName
              }}</span>
            </div>
          </div>

          <div>
            <div
              :style="{ backgroundImage: 'url(' + videoSrc.videoImgsrc + ')' }"
              class="history-info position-relative"
            >
              <span
                @click="dialogVisible = true"
                class="popup-with-zoom-anim play-view text-center pl-3"
              >
                <span class="video-play-icon">
                  <span
                    style="font-size: 30px"
                    class="fa fa-play iconfont icon-24gf-play"
                  ></span>
                </span>
              </span>
              <div id="small-dialog" class="zoom-anim-dialog mfp-hide">
                <div style="width: 100%; height: auto" class="videos"></div>
              </div>
            </div>
          </div>

          <div id="small-dialog" class="zoom-anim-dialog mfp-hide"></div>
        </div>
      </div>
    </section>
    <el-dialog
      :visible.sync="dialogVisible"
      width="85%"
      heigth="80vh"
      top="10vh"
      :before-close="handleClose"
    >
      <video
        ref="videoPlayer"
        controls
        :src="videoSrc.videoUrl"
        controlslist="nodownload"
        style="width: 100%; height: 100%; object-fit: fill"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { videourl } from "@/api/video/index";
export default {
  data() {
    return {
      dialogVisible: false,
      videoSrc: {},
      backgroundImg: "",
      queryParams: {
        pageNum: 1,
        pageSize: 1,
        isShow: 0,
      },
      videoOption: 0,
      videoList: [],
    };
  },
  mounted() {
    // this.getMouseEvent();
    this.getVideourl();
  },
  methods: {
    changeVideo(e) {
      this.videoOption = e;
      this.videoSrc = this.videoList[e];
    },

    getVideourl() {
      videourl(this.queryParams).then((res) => {
        this.videoList = res.rows;
        this.videoSrc = res.rows[0];
        // this.backgroundImg = res.rows[0].videoImgsrc;
      });
    },

    handleClose() {
      this.dialogVisible = false;
      // 暂停视频
      this.$refs.videoPlayer.pause();
    },
    // 获取鼠标位置
    getMouseEvent() {
      document.addEventListener("mousemove", (e) => {
        // console.log(`Mouse X: ${e.clientX}, Mouse Y: ${e.clientY}`);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.video_title {
  width: 100%;
  margin: auto auto 5px auto;
  height: 30px;
  // background: red;
  .title_text {
    float: left;
    width: 33%;
    text-align: center;
    line-height: 30px;
    font-size: 18px;
    cursor: pointer;
    .sb {
      padding: 6px 15px 6px 15px;
      background: #0a529b;
      border-radius: 5px;
      color: #fff;
    }
  }
  .title_text:hover {
    color: #651984;
    font-size: 20px;
  }
  // .title_text ::before{
  //   content: " ";
  //   display: block;
  //   width: 10px;
  //   height: 2px;
  //   position: absolute;
  //   top: 20px;
  //   left: 10px;
  //   background: red;
  // }
}
</style>